<card name="Toastr">
  <div card content>
    <div class="d-flex mx-n2">
      <button class="btn btn-secondary mx-2"
              (click)="toastr.info('Hello world!', 'Toastr info!', {timeOut: 50000});">
        Info
      </button>

      <button class="btn btn-success mx-2"
              (click)="toastr.success('Hello world!', 'Toastr fun!');">
        Success
      </button>

      <button class="btn btn-danger mx-2"
              (click)="toastr.error('Hello world!', 'Toastr danger!');">
        Danger
      </button>

      <button class="btn btn-warning mx-2"
              (click)="toastr.warning('Hello world!', 'Toastr warning!');">
        Warning
      </button>
    </div>
  </div>
</card>
